<script lang="ts">
    import { openModal } from 'svelte-modals';
    import ImageCarouselModal from './modals/ImageCarouselModal.svelte';

    export let images: string[] = null;

    function handleClick() {
        openModal(ImageCarouselModal, {
            carouselImages: images,
        });
    }
</script>

<div class="image-preview-container" on:click={handleClick}>
    {#each images as image}
        <div class="image-preview-item">
            <img src={image} alt="" />
        </div>
    {/each}
</div>

<style>
    .image-preview-container {
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 10px 0;
    }

    .image-preview-item {
        height: 64px;
        background-color: white;
        width: 100px;
        margin-right: 10px;
    }

    .image-preview-item img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }
</style>
